/**
 * Copyright (c) Qwoach LLC 2025. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 17.09.25
 *
 */

import DbBaseObject from "@shared/DbBaseObject";
import {TodoGroupEnum, TlswTodoTypeEnum} from "@tl/core/modules/commission/model/todo/TLSWTodoTemplate";
import {DueDateTypeEnum} from "@shared/Todo/DueDateTypeEnum";

export default class TodoItem extends DbBaseObject {

	clientId: string = null
	clientName: string = null

	title: string = null
	isCompleted: boolean = false
	dueDateMs: number = null // when the todo is due. If sessionJournalEntryId is set, this is synced from the "session start" time
	completedDateMs: number = null

	hasNote: boolean = false
	noteTitle: string = null
	noteContent: string = null

	dueDateType: DueDateTypeEnum = DueDateTypeEnum.CUSTOM

	sessionJournalEntryId: string = null // link to session to sync due date (optional)
	sessionName: string = null
	activeShiftMs: number = 14 * 24 * 60 * 60 * 1000 // how much time before the session the todo becomes active.
	dueDateShiftMs: number = 0 // how much to shift the due date before/after. E.g. -1 hour = 1 hour before the base due date

	activeAfterMs: number = null // when the todo becomes active. Is sessionJournalEntryId, calculated as "session start time" - activeShiftMs

	type: TlswTodoTypeEnum = TlswTodoTypeEnum.CUSTOM
	group: TodoGroupEnum = TodoGroupEnum.CUSTOM

	constructor(options = {}) {
		super(options);

		this.applyOptions(options);

		// this.title = options.title || null;
		// this.isCompleted = options.isCompleted || false;
		// this.dueDateMs = options.dueDateMs || null;
		// this.completedDateMs = options.completedDateMs || null;
		//
		// this.hasNote = options.hasNote || false;
		// this.noteTitle = options.noteTitle || null;
		//
		// this.sessionJournalEntryId = options.sessionJournalEntryId || null;
		// this.sessionName = options.sessionName || null;
		// if(options.activeShiftMs){
		// 	this.activeShiftMs = options.activeShiftMs;
		// }
		// this.dueDateShiftMs = options.dueDateShiftMs || 0;
		//
		// this.activeAfterMs = options.activeAfterMs || null;
		// if(options.isActiveImmediately){
		// 	this.activeAfterMs = 0
		// }
		//
		// this.type = options.type || TlswTodoTypeEnum.CUSTOM;
		// this.group = options.group || TodoGroupEnum.CUSTOM;
		//
		// this.dueDateType = options.dueDateType || DueDateTypeEnum.CUSTOM;
	}

	syncFromClientProfile(clientProfile){
		this.clientId = clientProfile.id;
		this.clientName = clientProfile.name;
	}

	setDueDateTypeSession(journalEntry) {
		if (!journalEntry) {
			return;
		}
		this.sessionJournalEntryId = journalEntry.id;
		this.sessionName = journalEntry.titleFormatted()
		this.dueDateType = DueDateTypeEnum.SESSION;
		this.setDueDate(journalEntry.startTimeMs);
	}

	setDueDateTypeEndOfContract(contractEndDateMs) {
		this.dueDateType = DueDateTypeEnum.END_OF_CONTRACT;
		this.setDueDate(contractEndDateMs);
	}

	setDueDate(dueDateMs) {
		if(dueDateMs){
			this.dueDateMs = dueDateMs + this.dueDateShiftMs;
			this.activeAfterMs = this.dueDateMs - this.activeShiftMs;
		} else {
			this.dueDateMs = null
			this.activeAfterMs = null
		}
	}

	setCompleted(isCompleted = true) {
		this.isCompleted = isCompleted;
		this.syncCheck()
	}

	hasCompletedDate(){
		return this.isCompleted && this.completedDateMs !== null;
	}

	syncCheck(){
		this.completedDateMs = this.isCompleted ? Date.now() : null;
	}

	isConnectedToSession(){
		return this.sessionJournalEntryId !== null
	}
	needsSyncFromSession(){
		return this.isConnectedToSession() && this.dueDateMs === null;
	}

	isDueDateTypeSession(){
		return this.dueDateType === DueDateTypeEnum.SESSION;
	}

	isDueDateTypeCustom(){
		return this.dueDateType === DueDateTypeEnum.CUSTOM;
	}

	isDueDateTypeEndOfContract(){
		return this.dueDateType === DueDateTypeEnum.END_OF_CONTRACT;
	}

	getSessionName(){
		return this.sessionName || "Session";
	}

	static fromIndex(item){
		return new TodoItem({
			id: item.id,
			title: item.title,
			dueDateMs: item.dueDateMs,
			activeAfterMs: item.activeAfterMs,
		})
	}

}
